// 转移到const文件，减少组件文件长度
const STEP_ENUM = {
  basicInfo: 0,
  personalInfo: 1,
  bankInfo: 2,
  educationsInfo: 3,
  worksInfo: 4,
  declaration: 5,
  healthInfo: 6,
  commitment: 7,
};

// 转移到const文件，减少组件文件长度
const BACKGROUND_STEP_ENUM = {
  personalInfo: 0,
  educationsInfo: 1,
  worksInfo: 2,
  declaration: 3,
};

// 转移到const文件，减少组件文件长度
// 操作按钮
const btnsMap = {
  edit: {
    code: 'edit',
    label: '编辑',
    type: 'normal',
  },
  prev: {
    code: 'prev',
    label: '上一步',
    type: 'normal',
  },
  next: {
    code: 'next',
    label: '下一步',
    type: 'primary',
  },
  preview: {
    code: 'preview',
    label: '预览',
    type: 'normal',
  },
  submit: {
    code: 'submit',
    label: '提交',
    type: 'primary',
  },
  promise: {
    code: 'promise',
    label: '',
    type: '',
  },
  save: {
    code: 'save',
    label: '保存',
    type: 'normal',
  },
};

export { STEP_ENUM, BACKGROUND_STEP_ENUM, btnsMap };
